import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/Home';
import { HsLookupPage } from './pages/HsLookup';
import { DutyCalcPage } from './pages/DutyCalc';
import { DocGeneratorPage } from './pages/DocGenerator';
import { TnvedMatcherPage } from './pages/TnvedMatcher';
import { LoginPage } from './pages/Login';
import { UploadPage } from './pages/Upload';
import { DealsPage, DealDetailPage } from './pages/Deals';
import { RequireAuth } from './auth/RequireAuth';

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="upload" element={<RequireAuth><UploadPage /></RequireAuth>} />
        <Route path="deals" element={<RequireAuth><DealsPage /></RequireAuth>} />
        <Route path="deals/:dealId" element={<RequireAuth><DealDetailPage /></RequireAuth>} />
        <Route path="hs-lookup" element={<HsLookupPage />} />
        <Route path="duty-calc" element={<DutyCalcPage />} />
        <Route path="doc-generator" element={<DocGeneratorPage />} />
        <Route path="tnved-matcher" element={<TnvedMatcherPage />} />
        <Route path="*" element={<HomePage />} />
      </Route>
    </Routes>
  );
}
